import { render } from "./PageIntroComponent.vue?vue&type=template&id=be093344"
import script from "./PageIntroComponent.vue?vue&type=script&lang=js"
export * from "./PageIntroComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__